
<app-spinner *ngIf="loading" [fullScreen]="true" [loading]="loading" [text]="'LOADING' | translate"></app-spinner>

<div class="container">
    <div class="logo-container">
      <img src="https://s3.eu-north-1.amazonaws.com/menuload.com/app/logo.webp" alt="MenuLoad" class="logo">
    </div>
  
    <div *ngIf="loading" class="loading-container">
        <p>{{ 'verification.loading' | translate }}</p>
        <div class="spinner"></div>
      </div>
      
      <div *ngIf="!loading && !error" class="success-message">
        <p>{{ 'verification.success' | translate }}</p>
        <p>{{ 'verification.redirecting' | translate }}</p>
      </div>
      
      <div *ngIf="error" class="error-message">
        <p>{{ 'verification.error' | translate }}</p>
        <a href="/" class="btn btn-primary">{{ 'verification.home' | translate }}</a>
    </div>
</div>

